var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppHeading',{staticClass:"section-heading",attrs:{"tag":_vm.tag}},[(_vm.icon)?_c('AppIcon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }